import React from 'react';

function Footer(props) {

  return (
    <footer id="main-footer" className="main-footer">
      <div className="social-links">
        <a
          href="https://wa.me/+41768283036"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link whatsapp-link"
          aria-label="Contact us on WhatsApp"
        >
          <img
            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20175.216%20175.552'%3e%3cpath%20fill='%23FFFFFF'%20d='M87.184%2025.227c-33.733%200-61.166%2027.423-61.178%2061.13a60.98%2060.98%200%200%200%209.349%2032.535l1.455%202.312-6.179%2022.559%2023.146-6.069%202.235%201.324c9.387%205.571%2020.15%208.518%2031.126%208.524h.023c33.707%200%2061.14-27.426%2061.153-61.135a60.75%2060.75%200%200%200-17.895-43.251%2060.75%2060.75%200%200%200-43.235-17.929z'/%3e%3cpath%20fill='%23FFFFFF'%20d='M68.772%2055.603c-1.378-3.061-2.828-3.123-4.137-3.176l-3.524-.043c-1.226%200-3.218.46-4.902%202.3s-6.435%206.287-6.435%2015.332%206.588%2017.785%207.506%2019.013%2012.718%2020.381%2031.405%2027.75c15.529%206.124%2018.689%204.906%2022.061%204.6s10.877-4.447%2012.408-8.74%201.532-7.971%201.073-8.74-1.685-1.226-3.525-2.146-10.877-5.367-12.562-5.981-2.91-.919-4.137.921-4.746%205.979-5.819%207.206-2.144%201.381-3.984.462-7.76-2.861-14.784-9.124c-5.465-4.873-9.154-10.891-10.228-12.73s-.114-2.835.808-3.751c.825-.824%201.838-2.147%202.759-3.22s1.224-1.84%201.836-3.065.307-2.301-.153-3.22-4.032-10.011-5.666-13.647'/%3e%3c/svg%3e"
            alt="WhatsApp"
            className="social-icon"
          />
        </a>
        <a
          href="https://t.me/altcoinomy"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link telegram-link"
          aria-label="Contact us on Telegram"
        >
          <img
            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2048%2048'%3e%3cpath%20fill='%23FFFFFF'%20d='M5.83,23.616c12.568-5.529,28.832-12.27,31.077-13.203c5.889-2.442,7.696-1.974,6.795,3.434%20c-0.647,3.887-2.514,16.756-4.002,24.766c-0.883,4.75-2.864,5.313-5.979,3.258c-1.498-0.989-9.059-5.989-10.7-7.163%20c-1.498-1.07-3.564-2.357-0.973-4.892c0.922-0.903,6.966-6.674,11.675-11.166c0.617-0.59-0.158-1.559-0.87-1.086%20c-6.347,4.209-15.147,10.051-16.267,10.812c-1.692,1.149-3.317,1.676-6.234,0.838c-2.204-0.633-4.357-1.388-5.195-1.676%20C1.93,26.43,2.696,24.995,5.83,23.616z'/%3e%3c/svg%3e"
            alt="Telegram"
            className="social-icon"
          />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
